var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pb-2"},[_c('div',{staticClass:"profile-pic-sheet",style:({ backgroundImage: ("url(" + _vm.source + ")")})}),(_vm.accountActive)?_c('div',{staticClass:"profile-active"}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }